// extracted by mini-css-extract-plugin
export default {"page":"tV-z","cartModal":"uV-z","checkout":"vV-z","placeholder":"wV-z","account":"xV-z"};